import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/useLocale';
import { useMonthOptions } from '@/hooks/useMonthOptions';
import { useHomeFilter } from './HomeFilterContext';

const STATUS_OPTIONS = ['SUBMITTED', 'APPROVED', 'PAID'] as const;

export function HomeFilterBar() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { selectedMonth, setSelectedMonth, selectedStatuses, toggleStatus } = useHomeFilter();
  const monthOptions = useMonthOptions(locale);

  return (
    <div className="flex items-center justify-start gap-2 px-4 md:px-10 mt-4">
      <div className="flex items-center gap-1 rounded-full bg-white p-1 shadow-sm" style={{ border: '1px solid #e5e7eb' }}>
        {STATUS_OPTIONS.map((s) => {
          const active = selectedStatuses.includes(s);
          return (
            <button
              key={s}
              type="button"
              onClick={() => toggleStatus(s)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition-all ${
                active
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'text-slate-500 hover:bg-slate-50'
              }`}
            >
              {t(`status.${s.toLowerCase()}`)}
            </button>
          );
        })}
      </div>
      <select
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
        className="appearance-none rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-primary-200"
        style={{ border: '1px solid #e5e7eb' }}
      >
        {monthOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
